<!-- 
  © 2025 Ananda Kumar. All rights reserved.
  Unauthorized copying of this file, via any medium, is strictly prohibited.
-->
<nav class="navbar navbar-expand-md sticky-top section-header no-user-select">
  <div class="container-fluid d-flex flex-row align-items-center justify-content-between px-3">
    <a class="h-100" [href]="tenantService.getTenantKey()" *ngIf="(title$ | async) == ''">
      <img src="/assets/images/kinvyt-gold.png" class="kinvyt-logo" height="40" width="auto" />
    </a>
    <div *ngIf="(title$ | async) != ''">
      <span class="back-arrow me-2" (click)="goBack()">&#8592;</span>
      <span class="section-title">
        {{ title$ | async }}
      </span>
    </div>

    <div class="d-flex flex-row gap-2">
      <a *ngIf="showEventUpdates" class="d-flex align-items-center text-decoration-none p-2 pe-0 cursor-pointer">
        <img src="icons/notification-unread.svg" width="28px" id="get-updates-icon" routerLink="event/updates" />
      </a>
      <span class="p-2 pe-0 h-100 d-flex align-items-center gap-1" role="button" data-bs-toggle="offcanvas"
        data-bs-target="#offcanvasNavbar" aria-controls="offcanvasNavbar">
        <img src="/assets/images/list-gold-hamburger.svg" width="20px" class="menu-ham" />
        <span class="t-golden-gradient-text"> Menu </span>
      </span>
    </div>
  </div>
</nav>

<div class="offcanvas offcanvas-end custom-offcanvas no-user-select" tabindex="-1" id="offcanvasNavbar"
  aria-labelledby="offcanvasNavbarLabel">
  <div class="offcanvas-header pb-1">
    <h5 class="offcanvas-title fw-bold" id="offcanvasNavbarLabel">Menu</h5>
    <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
  </div>
  <hr class="p-1 m-1" />

  <div class="offcanvas-body pt-0 flex-grow-1 overflow-auto no-user-select pb-5">
    <ul class="navbar-nav justify-content-start pe-3">
      <li class="nav-item" *ngFor="let item of menuItems; trackBy: trackById">
        <div class="d-flex align-items-center gap-2">
          <a class="nav-link d-flex align-items-center gap-2 flex-grow-1"
            [routerLink]="tenantService.getTenantPrefixedPath(item.routeUrl)" routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }" #rla="routerLinkActive" data-bs-dismiss="offcanvas">
            <img [src]="item.image" />
            <span>{{ item.label }}</span>
            <span *ngIf="item.isExclusive" class="badge-pill">Exclusive</span>
          </a>
          <!-- Logout button for menus with active tokens -->
          <button *ngIf="getMenusWithTokens().includes(item.routeUrl)" (click)="logoutFromMenu(item.routeUrl)"
            class="btn btn-sm btn-outline-danger" title="Clear token for this menu"
            style="padding: 0.25rem 0.5rem; font-size: 0.75rem;">
            <i class="fas fa-sign-out-alt"></i>
          </button>
        </div>
      </li>
      <hr *ngIf="showUpdates" />
      <li *ngIf="showUpdates">
        <a class="cursor-pointer text-decoration-none d-flex align-items-center gap-2" data-bs-dismiss="offcanvas">
          <img src="/assets/images/whatsapp.svg" width="24px" />
          <span class="get-updates-text" (click)="onGetUpdates()">Get Updates on Whatsapp</span>
        </a>
      </li>
      <hr />
      <!-- Theme Switcher -->
      <!-- <li class="nav-item">
        <div class="nav-link d-flex align-items-center gap-2">
          <i class="fas fa-palette"></i>
          <span>Theme</span>
          <app-theme-switcher></app-theme-switcher>
        </div>
      </li>
      <hr /> -->
    </ul>
  </div>

  <div class="sticky-footer">
    <ul class="navbar-nav">
      <li class="nav-item" *ngIf="isAdmin$ | async">
        <a class="nav-link d-flex align-items-center gap-2"
          [routerLink]="tenantService.getTenantPrefixedPath('admin/dashboard')" routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }" data-bs-dismiss="offcanvas">
          <i class="fas fa-user-shield"></i>
          Admin Dashboard
        </a>
      </li>
      <li class="nav-item" *ngIf="(isAdmin$ | async) || (isLoggedIn$ | async);">
        <button class="nav-link d-flex align-items-center gap-2" (click)="logout()" data-bs-dismiss="offcanvas">
          <i class="fas fa-sign-out"></i>
          Logout
        </button>
      </li>
    </ul>
  </div>
</div>